import React from 'react';
import './Contact.css'

const Contact = () => {
    return (
        <div className='contact text-center pt-5 mt-5'>
            <div className="container">
                <h4 className='head-color fw-bold'>CONTACT US</h4>
                <h1 className='text-white fs-1'>Always Contact with Us</h1>
                <div className="col-md-8 mx-auto">
                    <form action="">
                        <input className='form-control mt-5 p-4' type="email" name="email" id="" placeholder='Email Address *' required/>
                        <input className='form-control mt-4 p-4' type="text" name="email" id="" placeholder='Subject *' required/>
                        <textarea className='form-control mt-4 p-4' name="" id="" cols="30" rows="5" placeholder='Your Message' required></textarea>
                        <button type='submit ' className='btn-similar mt-4 px-5'>SUBMIT</button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;